import { Container, Heading, Text, Toggle } from '@amelio/ui-library';
import { useEffect, useState } from 'react';

import {
    useCompanyPreferences,
    useUpdateCompanyPreferences,
} from '@/api/performance-company-preferences';
import { useAmelioTranslations } from '@/hooks';
import { useError } from '@/hooks/utils/useError';

export const TemplateSettings = () => {
    const { t } = useAmelioTranslations();
    const { handleError } = useError();

    const { data: preferences, isLoading } = useCompanyPreferences();
    const { mutateAsync: updatePreferences, isPending: isUpdating } = useUpdateCompanyPreferences();

    const [localChecked, setLocalChecked] = useState(
        preferences?.allowManagersToAccessCompanyTemplates,
    );

    useEffect(() => {
        setLocalChecked(preferences?.allowManagersToAccessCompanyTemplates);
    }, [preferences]);

    const handleToggleChange = async (checked: boolean) => {
        try {
            const response = await updatePreferences({
                allowManagersToAccessCompanyTemplates: checked,
            });
            setLocalChecked(response.allowManagersToAccessCompanyTemplates);
        } catch (error) {
            // Revert on error
            setLocalChecked(preferences?.allowManagersToAccessCompanyTemplates);
            handleError({ error });
        }
    };

    return (
        // The page owns the only card, so the settings are a row inside it: a heading and the box the
        // toggle sits in, nothing around them.
        <Container gap={'md'}>
            <Heading
                level={3}
                weight={'semibold'}
            >
                {t('common.settings')}
            </Heading>

            <div className={'flex w-fit items-start gap-4 rounded-2xl bg-white p-7'}>
                <div>
                    <Heading level={5}>{t('templateManagement.template.settings.heading')}</Heading>

                    <Text
                        className={'mt-3 max-w-3xl'}
                        size={'small'}
                    >
                        {t('templateManagement.template.settings.description')}
                    </Text>
                </div>

                <Toggle
                    checked={localChecked}
                    disabled={isLoading || isUpdating}
                    onChange={handleToggleChange}
                    size={'md'}
                />
            </div>
        </Container>
    );
};
